/* tslint:disable */
/* eslint-disable */
/**
 * SPD
 * Opis api SPD
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GetCompanyBatteryDto } from './GetCompanyBatteryDto';
import {
    GetCompanyBatteryDtoFromJSON,
    GetCompanyBatteryDtoFromJSONTyped,
    GetCompanyBatteryDtoToJSON,
} from './GetCompanyBatteryDto';
import type { GetDictionaryDto } from './GetDictionaryDto';
import {
    GetDictionaryDtoFromJSON,
    GetDictionaryDtoFromJSONTyped,
    GetDictionaryDtoToJSON,
} from './GetDictionaryDto';
import type { GetHealthcareFacilityDto } from './GetHealthcareFacilityDto';
import {
    GetHealthcareFacilityDtoFromJSON,
    GetHealthcareFacilityDtoFromJSONTyped,
    GetHealthcareFacilityDtoToJSON,
} from './GetHealthcareFacilityDto';

/**
 * 
 * @export
 * @interface GetCompanyDto
 */
export interface GetCompanyDto {
    /**
     * 
     * @type {string}
     * @memberof GetCompanyDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof GetCompanyDto
     */
    name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetCompanyDto
     */
    officialName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetCompanyDto
     */
    address?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetCompanyDto
     */
    nip?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetCompanyDto
     */
    taxIdentifier?: string | null;
    /**
     * 
     * @type {GetDictionaryDto}
     * @memberof GetCompanyDto
     */
    taxCountryCode?: GetDictionaryDto | null;
    /**
     * 
     * @type {string}
     * @memberof GetCompanyDto
     */
    email?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetCompanyDto
     */
    emailInvoices?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof GetCompanyDto
     */
    externalReferral?: boolean | null;
    /**
     * 
     * @type {GetCompanyDto}
     * @memberof GetCompanyDto
     */
    branch?: GetCompanyDto | null;
    /**
     * 
     * @type {Array<GetCompanyBatteryDto>}
     * @memberof GetCompanyDto
     */
    companiesBatteries?: Array<GetCompanyBatteryDto> | null;
    /**
     * 
     * @type {GetHealthcareFacilityDto}
     * @memberof GetCompanyDto
     */
    healthcareFacility?: GetHealthcareFacilityDto | null;
    /**
     * 
     * @type {boolean}
     * @memberof GetCompanyDto
     */
    monthlySettlement: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetCompanyDto
     */
    invoicesSettlement: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetCompanyDto
     */
    active: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetCompanyDto
     */
    blockedForPrint: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetCompanyDto
     */
    autoInvoice: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetCompanyDto
     */
    autoApproveInvoice: boolean;
    /**
     * 
     * @type {number}
     * @memberof GetCompanyDto
     */
    invoicePaymentDays?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof GetCompanyDto
     */
    invoiceIncludeExaminedNames: boolean;
}

/**
 * Check if a given object implements the GetCompanyDto interface.
 */
export function instanceOfGetCompanyDto(value: object): value is GetCompanyDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('monthlySettlement' in value) || value['monthlySettlement'] === undefined) return false;
    if (!('invoicesSettlement' in value) || value['invoicesSettlement'] === undefined) return false;
    if (!('active' in value) || value['active'] === undefined) return false;
    if (!('blockedForPrint' in value) || value['blockedForPrint'] === undefined) return false;
    if (!('autoInvoice' in value) || value['autoInvoice'] === undefined) return false;
    if (!('autoApproveInvoice' in value) || value['autoApproveInvoice'] === undefined) return false;
    if (!('invoiceIncludeExaminedNames' in value) || value['invoiceIncludeExaminedNames'] === undefined) return false;
    return true;
}

export function GetCompanyDtoFromJSON(json: any): GetCompanyDto {
    return GetCompanyDtoFromJSONTyped(json, false);
}

export function GetCompanyDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetCompanyDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'] == null ? undefined : json['name'],
        'officialName': json['officialName'] == null ? undefined : json['officialName'],
        'address': json['address'] == null ? undefined : json['address'],
        'nip': json['nip'] == null ? undefined : json['nip'],
        'taxIdentifier': json['taxIdentifier'] == null ? undefined : json['taxIdentifier'],
        'taxCountryCode': json['taxCountryCode'] == null ? undefined : GetDictionaryDtoFromJSON(json['taxCountryCode']),
        'email': json['email'] == null ? undefined : json['email'],
        'emailInvoices': json['emailInvoices'] == null ? undefined : json['emailInvoices'],
        'externalReferral': json['externalReferral'] == null ? undefined : json['externalReferral'],
        'branch': json['branch'] == null ? undefined : GetCompanyDtoFromJSON(json['branch']),
        'companiesBatteries': json['companiesBatteries'] == null ? undefined : ((json['companiesBatteries'] as Array<any>).map(GetCompanyBatteryDtoFromJSON)),
        'healthcareFacility': json['healthcareFacility'] == null ? undefined : GetHealthcareFacilityDtoFromJSON(json['healthcareFacility']),
        'monthlySettlement': json['monthlySettlement'],
        'invoicesSettlement': json['invoicesSettlement'],
        'active': json['active'],
        'blockedForPrint': json['blockedForPrint'],
        'autoInvoice': json['autoInvoice'],
        'autoApproveInvoice': json['autoApproveInvoice'],
        'invoicePaymentDays': json['invoicePaymentDays'] == null ? undefined : json['invoicePaymentDays'],
        'invoiceIncludeExaminedNames': json['invoiceIncludeExaminedNames'],
    };
}

export function GetCompanyDtoToJSON(value?: GetCompanyDto | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'name': value['name'],
        'officialName': value['officialName'],
        'address': value['address'],
        'nip': value['nip'],
        'taxIdentifier': value['taxIdentifier'],
        'taxCountryCode': GetDictionaryDtoToJSON(value['taxCountryCode']),
        'email': value['email'],
        'emailInvoices': value['emailInvoices'],
        'externalReferral': value['externalReferral'],
        'branch': GetCompanyDtoToJSON(value['branch']),
        'companiesBatteries': value['companiesBatteries'] == null ? undefined : ((value['companiesBatteries'] as Array<any>).map(GetCompanyBatteryDtoToJSON)),
        'healthcareFacility': GetHealthcareFacilityDtoToJSON(value['healthcareFacility']),
        'monthlySettlement': value['monthlySettlement'],
        'invoicesSettlement': value['invoicesSettlement'],
        'active': value['active'],
        'blockedForPrint': value['blockedForPrint'],
        'autoInvoice': value['autoInvoice'],
        'autoApproveInvoice': value['autoApproveInvoice'],
        'invoicePaymentDays': value['invoicePaymentDays'],
        'invoiceIncludeExaminedNames': value['invoiceIncludeExaminedNames'],
    };
}

